module.exports = __webpack_public_path__ + "static/media/user-plus.5047d004.svg";